module.exports = __webpack_public_path__ + "static/media/insta-icon.cd6663cf.svg";